module.exports = __webpack_public_path__ + "img/openstack-white.4adc7b75.svg";